'use client';

import { motion } from 'framer-motion';
import { ContactLinks, NavigationItems } from '@/types/types';
import Logo from '@/app/shared/common/Logo';
import MainNavigation from './MainNavigation';
import UtilityNavigation from './UtilityNavigation';
import MobileMainNav from './MobileMainNav';

interface NavbarProps {
  navItems: NavigationItems;
  contactLinks: ContactLinks;
  iconsData: { [key: string]: React.ReactNode };
}

export default function Navbar({
  navItems,
  contactLinks,
  iconsData,
}: NavbarProps) {
  return (
    <motion.section
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: 'easeOut', delay: 0.1 }}
      className='bg-background border-b border-designer-border z-50 h-navbar w-full'
    >
      <nav
        className='hidden lg:flex items-center justify-between'
        suppressHydrationWarning
      >
        <div className='flex items-center gap-2 pt-2 pb-2'>
          <Logo />
        </div>
        <div className='flex-grow' />
        <MainNavigation navItems={navItems} />
        <div className='flex-grow' />
        <UtilityNavigation contactLinks={contactLinks} iconsData={iconsData} />
      </nav>

      <MobileMainNav
        navItems={navItems}
        contactLinks={contactLinks}
        iconsData={iconsData}
      />
    </motion.section>
  );
}
